// Infinite scroll + recordar estado al volver con BACK

const COLLECTION_STATE_KEY = 'sns_collection_state_v1';

// (NO tocamos scrollRestoration aquí, lo manejamos con la clase en <html>)

function isBackNavigation() {
  try {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries && navEntries.length > 0) {
      return navEntries[0].type === 'back_forward';
    }
    if (performance && performance.navigation) {
      // API vieja, pero como fallback
      return performance.navigation.type === 2;
    }
  } catch (e) {
    console.warn('InfiniteScroll: no se pudo detectar tipo de navegación', e);
  }
  return false;
}

class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('#product-grid');
    this.pagination = document.querySelector('.pagination-wrapper');
    
    console.log('=== Infinite Scroll Debug ===');
    console.log('Container:', this.container);
    console.log('Pagination:', this.pagination);
    
    if (!this.container) {
      console.error('Product grid container not found');
      this.showBodyIfHidden();
      return;
    }
    
    if (!this.pagination) {
      console.error('Pagination wrapper not found');
      this.showBodyIfHidden();
      return;
    }

    // ---- Estado de colección (para BACK) ----
    this.stateKey = this.getStateKey();
    this.isBack = isBackNavigation();
    this.restoredState = this.isBack ? this.restoreState() : null;
    
    this.nextPageUrl =
      (this.restoredState && this.restoredState.nextPageUrl) ||
      this.getNextPageUrl();

    console.log('Next page URL:', this.nextPageUrl);
    
    if (!this.nextPageUrl) {
      console.log('No next page - probably only 1 page of products');
      this.pagination.style.display = '';
      // Igual guardamos estado al salir, por si acaso
      window.addEventListener('beforeunload', () => {
        this.saveState();
      });
      this.showBodyIfHidden();
      return;
    }
    
    this.loading = false;
    this.preloading = false;
    this.preloadThreshold = 2000;
    this.loadThreshold = 1200;
    this.cachedPage = null;
    this.initialized = false;
    
    this.init();

    // Guardar estado SIEMPRE al salir de la página
    window.addEventListener('beforeunload', () => {
      this.saveState();
    });

    // Ya podemos mostrar el body (si estaba oculto)
    this.showBodyIfHidden();
  }

  showBodyIfHidden() {
    // Quitamos la clase global que oculta el body
    document.documentElement.classList.remove('sns-restore-pending');
  }

  // =============== ESTADO (SESSIONSTORAGE) =================

  getStateKey() {
    // Una key por colección (por path)
    return `${COLLECTION_STATE_KEY}:${window.location.pathname}`;
  }

  restoreState() {
    try {
      const raw = sessionStorage.getItem(this.stateKey);
      if (!raw) {
        console.log('InfiniteScroll: no saved collection state');
        return null;
      }

      const state = JSON.parse(raw);
      const savedPath = (state.url || '').split('?')[0];
      const currentPath = window.location.pathname;

      if (savedPath !== currentPath) {
        console.log('InfiniteScroll: saved state is for different collection, ignoring');
        return null;
      }

      if (state.html) {
        console.log('InfiniteScroll: restoring product-grid HTML from saved state');
        this.container.innerHTML = state.html;
      }

      const targetScroll = typeof state.scrollY === 'number' ? state.scrollY : 0;

      // Restauramos el scroll lo antes posible
      window.scrollTo(0, targetScroll);
      console.log('InfiniteScroll: scroll restored to', targetScroll);

      console.log('InfiniteScroll: restored nextPageUrl from state:', state.nextPageUrl);
      return state;
    } catch (e) {
      console.warn('InfiniteScroll: error restoring collection state', e);
      return null;
    }
  }

  saveState() {
    try {
      if (!this.container) return;

      const state = {
        url: window.location.pathname + window.location.search,
        html: this.container.innerHTML,
        nextPageUrl: this.nextPageUrl,
        scrollY: window.scrollY,
        timestamp: Date.now()
      };

      sessionStorage.setItem(this.stateKey, JSON.stringify(state));
      console.log('InfiniteScroll: collection state saved');
    } catch (e) {
      console.warn('InfiniteScroll: error saving collection state', e);
    }
  }
  
  // =============== LÓGICA EXISTENTE =======================

  init() {
    this.hidePagination();
    this.setupObserver();
    this.boundHandleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.boundHandleScroll);
    this.initialized = true;
    console.log('✓ Infinite scroll initialized successfully');
    
    // Check initial scroll position after a short delay
    setTimeout(() => {
      this.checkInitialPosition();
    }, 200);
  }
  
  checkInitialPosition() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = pageHeight - scrollPosition;
    
    console.log('Initial distance from bottom:', distanceFromBottom);
    
    // If already near bottom when page loads, trigger loading
    if (distanceFromBottom < this.preloadThreshold && !this.preloading) {
      console.log('Page loaded while scrolled down - triggering preload');
      this.preloading = true;
      this.preloadNextPage();
    }
    
    if (distanceFromBottom < this.loadThreshold && !this.loading) {
      console.log('Page loaded at bottom - loading next page immediately');
      this.loadNextPage();
    }
  }
  
  hidePagination() {
    if (this.pagination) {
      this.pagination.style.display = 'none';
    }
  }
  
  getNextPageUrl() {
    if (!this.pagination) return null;
    
    // Dawn uses aria-label="Next page" for the next link
    let nextLink = this.pagination.querySelector('a[aria-label="Next page"]');
    
    if (!nextLink) {
      // Try with case-insensitive search
      nextLink = this.pagination.querySelector('a[aria-label*="next" i]');
    }
    
    if (!nextLink) {
      // Search by pagination__item-arrow class that is not disabled
      const arrows = this.pagination.querySelectorAll('.pagination__item-arrow');
      for (const arrow of arrows) {
        if (arrow.getAttribute('aria-label')?.toLowerCase().includes('next')) {
          nextLink = arrow;
          break;
        }
      }
    }
    
    if (nextLink && nextLink.href) {
      console.log('✓ Next link found:', nextLink.href);
      return nextLink.href;
    }
    
    console.log('Next page link not found');
    return null;
  }
  
  handleScroll() {
    if (this.loading || !this.nextPageUrl) return;
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = pageHeight - scrollPosition;
    
    // Preload when getting close
    if (distanceFromBottom < this.preloadThreshold && !this.preloading) {
      this.preloading = true;
      this.preloadNextPage();
    }
    
    // Show when reaching load threshold
    if (distanceFromBottom < this.loadThreshold) {
      this.loadNextPage();
    }
  }
  
  async preloadNextPage() {
    if (!this.nextPageUrl) return;
    
    console.log('⏳ Preloading:', this.nextPageUrl);
    
    try {
      const response = await fetch(this.nextPageUrl);
      this.cachedPage = await response.text();
      console.log('✓ Page preloaded');
    } catch (error) {
      console.error('❌ Error preloading:', error);
      this.preloading = false;
    }
  }
  
  async loadNextPage() {
    if (this.loading || !this.nextPageUrl) return;
    
    this.loading = true;
    this.showLoader();
    
    console.log('📥 Loading page:', this.nextPageUrl);
    
    try {
      let html;
      
      if (this.cachedPage) {
        html = this.cachedPage;
        this.cachedPage = null;
        console.log('✓ Using preloaded page');
      } else {
        const response = await fetch(this.nextPageUrl);
        html = await response.text();
        console.log('✓ Page downloaded');
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find product grid in new page
      const newProductGrid = doc.querySelector('#product-grid');
      
      if (!newProductGrid) {
        console.error('❌ Product grid not found in new page');
        this.loading = false;
        this.hideLoader();
        return;
      }
      
      // Get all items (li) from grid
      const newProducts = newProductGrid.querySelectorAll('li');
      console.log(`✓ Found ${newProducts.length} new products`);
      
      if (newProducts.length === 0) {
        console.warn('⚠️ No products in new page');
        this.nextPageUrl = null;
        this.loading = false;
        this.hideLoader();
        return;
      }
      
      // Add new products to current grid
      newProducts.forEach((product) => {
        const clonedProduct = product.cloneNode(true);
        this.container.appendChild(clonedProduct);
      });
      
      console.log(`✓ ${newProducts.length} products added to grid`);
      
      // Find next page in loaded HTML
      const newPagination = doc.querySelector('.pagination');
      if (newPagination) {
        const nextLink = newPagination.querySelector('a[aria-label="Next page"]') || 
                        newPagination.querySelector('a[aria-label*="next" i]');
        
        if (nextLink && nextLink.href) {
          this.nextPageUrl = nextLink.href;
          console.log('✓ Next URL:', this.nextPageUrl);
          
          // Preload next page
          this.preloading = false;
          setTimeout(() => {
            this.preloadNextPage();
          }, 500);
        } else {
          this.nextPageUrl = null;
          console.log('✓ No more pages - end of catalog');
        }
      } else {
        this.nextPageUrl = null;
        console.log('✓ No more pages');
      }
      
      // Reinitialize Shopify scripts if they exist
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
      
      // Dispatch custom event for other scripts
      window.dispatchEvent(new CustomEvent('infinitescroll:loaded', {
        detail: { productsAdded: newProducts.length }
      }));
      
    } catch (error) {
      console.error('❌ Error loading page:', error);
    } finally {
      this.loading = false;
      this.hideLoader();
    }
  }
  
  showLoader() {
    let loader = document.querySelector('.infinite-scroll-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'infinite-scroll-loader';
      loader.innerHTML = `
        <div class="loading-spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
          <p style="margin-top: 1rem; color: rgb(199, 199, 199); font-size: 1.4rem;">Loading...</p>
        </div>
      `;
      this.container.parentNode.insertBefore(loader, this.container.nextSibling);
    }
    loader.style.display = 'flex';
  }
  
  hideLoader() {
    const loader = document.querySelector('.infinite-scroll-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }
  
  setupObserver() {
    const observer = new MutationObserver(() => {
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    });
    
    observer.observe(this.container, {
      childList: true,
      subtree: false
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      new InfiniteScroll();
    }, 100);
  });
} else {
  setTimeout(() => {
    new InfiniteScroll();
  }, 100);
}
